import { useRef, useState } from "react";
import { ShoppingBag } from "lucide-react";

const PANEL_URL = "https://quick-order-system-29.emergent.host/";

export const Navbar = () => {
  const [logoClicks, setLogoClicks] = useState(0);
  const timerRef = useRef(null);

  const handleLogoClick = (e) => {
    e.preventDefault();
    const next = logoClicks + 1;
    if (timerRef.current) clearTimeout(timerRef.current);
    if (next >= 5) {
      setLogoClicks(0);
      window.open(PANEL_URL, "_blank", "noopener,noreferrer");
      return;
    }
    setLogoClicks(next);
    timerRef.current = setTimeout(() => setLogoClicks(0), 2500);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b-2 border-[#1A1A1A] bg-[#FDFBF7]"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-8">
        <a
          href="#top"
          data-testid="nav-logo-link"
          className="flex items-center select-none"
          onClick={handleLogoClick}
          aria-label="Deny's Burger & Fries ana sayfa"
        >
          <img
            src="/assets/logo.png"
            alt="Deny's Burger & Fries logosu"
            className="h-12 w-auto md:h-14"
            draggable={false}
          />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          <a
            data-testid="nav-link-menu"
            href="#menu"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            Menü
          </a>
          <a
            data-testid="nav-link-branches"
            href="#subeler"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            Şubeler
          </a>
          <a
            data-testid="nav-link-why-us"
            href="#neden-biz"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            Neden Biz
          </a>
          <a
            data-testid="nav-link-careers"
            href="#basvuru"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            İş Başvurusu
          </a>
          <a
            data-testid="nav-link-franchise"
            href="#bayilik"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            Bayilik
          </a>
          <a
            data-testid="nav-link-contact"
            href="#siparis"
            className="text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            İletişim
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            data-testid="nav-gelal-button"
            href="#subeler"
            className="btn-chunky flex items-center gap-2 bg-[#E63946] px-4 py-2 text-sm uppercase tracking-wide text-white"
          >
            <ShoppingBag size={16} strokeWidth={2.5} />
            Gel Al Sipariş
          </a>
        </div>
      </div>
    </header>
  );
};
